import { render, staticRenderFns } from "./TomaNew.vue?vue&type=template&id=315bcab8&scoped=true"
import script from "./TomaNew.vue?vue&type=script&lang=js"
export * from "./TomaNew.vue?vue&type=script&lang=js"
import style0 from "./TomaNew.vue?vue&type=style&index=0&id=315bcab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315bcab8",
  null
  
)

export default component.exports